export default __webpack_public_path__ + "static/1A-21ac6fe02f2387c1a92114316ccc310d.png";